import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TaskStatus, TaskStatusesSdkService } from '@vendasta/task-manager';
import { Observable } from 'rxjs';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { TaskManagerPersonaType } from '../task-status-changed.service';
import { TaskStatusChangedPanelComponent } from './task-status-changed-panel.component';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TaskService } from '../../../../../data-services/task.service';
import { UsersService } from '../../../../../data-services/users.service';
import { AutomationViewService } from '../../../../../automation/automation-view.service';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { SalespersonSelectorService } from '../../../../../data-services/salesperson-selector-service';

@Component({
  selector: 'automata-task-status-changed-panel',
  styleUrls: ['./task-status-changed-panel.component.scss'],
  templateUrl: './task-status-changed-panel.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    GalaxyWrapModule,
    MatAutocompleteModule,
    AutomationReplacementChipsComponent,
  ],
})
export class SalesTaskStatusChangedPanelComponent extends TaskStatusChangedPanelComponent implements OnInit {
  isProjectType = false;
  taskPersonaType = TaskManagerPersonaType.Salesperson;
  subtitleKey = 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_TASK_STATUS_CHANGED.TASK_STATUS_SUBTITLE_V2';
  assigneeFilterDescriptionKey = 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_TASK_STATUS_CHANGED.FILTERS.OTHER_FILTERS';
  nameFilterTitle = 'AUTOMATIONS.EDITOR.TRIGGERS.TASK_STATUS_CHANGED.FILTERS.TASK_NAME';

  statuses: TaskStatus[] = [
    { name: 'Open' },
    { name: 'In Progress' },
    { name: 'Waiting on Customer' },
    { name: 'Completed' },
  ] as TaskStatus[];

  service = this.injector.get(SalespersonSelectorService);

  constructor(
    @Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) protected readonly partnerId$: Observable<string>,
    protected readonly taskStatusesSdkService: TaskStatusesSdkService,
    protected readonly usersService: UsersService,
    protected readonly taskService: TaskService,
    protected readonly automationService: AutomationViewService,
    protected readonly injector: Injector,
  ) {
    super(partnerId$, taskStatusesSdkService, usersService, taskService, automationService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
